
import styled from "@emotion/styled";
import { createTheme } from "@mui/material/styles";

export const HeaderBox = styled.div`
  background-color: #fff;
  border-bottom: solid 8px #44a4eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  max-height: 64px;
  height: 64px;
  width: 100%;
  position: relative;
  z-index: 1201;
  @media (max-width: 767px) {
    height: auto;
    width: 100%;
    padding: 12px;
  }
  img {
    height: 35px;
    @media (max-width: 760px) {
      height: 30px;
    }
  }
  .bell {
    &::after {
      content: "";
      background-color: #999;
      position: absolute;
      top: 7px;
      right: 0;
      height: 24px;
      width: 1px;
    }
  }
`;
export const UserWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  padding-left: 12px;
  position: relative;
`;

export const theme = createTheme({
  typography: {
    fontFamily: ["Poppins, sans-serif"].join(","),
    variants: [],
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          color: "#666",
        },
      },
    },
  },
});

export const paperPropsCSSObj = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&::before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
}